import { createSelector } from 'reselect'
import {
    getRotation,
} from 'redux/appliedFilters/selectors'

import {
    Position,
    Rectangle,
} from 'helpers/math'
import { getUserScale } from 'redux/appliedFilters/selectors'
import { Vector } from '../../helpers/math.js'
import { isCurrentMediaSourceLoaded } from '../currentMedia/selectors'

export const getCanvas = state => state.canvas

export const getDefaultScale = createSelector(
    getCanvas,
    (state, viewId) => viewId,
    (canvas, viewId) => {
        if(! canvas.projections || ! canvas.projections[viewId])
        {
            return 1
        }

        return canvas.projections[viewId].defaultScale
    }
)

export const getScale = createSelector(
    getDefaultScale,
    getUserScale,
    (defaultScale, userScale) => defaultScale * userScale,
)

export const getCurrentImageRect = createSelector(
    getCanvas,
    canvas => canvas.imageRect
)

export const getProjection = createSelector(
    getCanvas,
    (state, viewId) => viewId,
    (canvas, viewId) => canvas.projections && canvas.projections[viewId]
)

export const getScaledCurrentImageRect = createSelector(
    getCurrentImageRect,
    getScale,
    (imageRect, scale) => imageRect.scale(scale)
)

export const computeViewData = createSelector(
    getScaledCurrentImageRect,
    getRotation,
    getProjection,
    (imageRect, rotation, { frame }) => {
        const offset = new Position(
            (imageRect.width / 2 - imageRect.position.x),
            (imageRect.height / 2 - imageRect.position.y),
        )

        frame = frame.rotate(rotation)

        const frameCenter = new Position(
            Math.round(frame.width / 2),
            Math.round(frame.height / 2)
        )

        return {
            offset,
            width: imageRect.width,
            height: imageRect.height,
            viewRect: new Rectangle(
                frame.width,
                frame.height,
                offset.move(frameCenter.convertToVector().invert()),
            ),
            rotation,
        }
    }
)

export const computeMinimapViewData = createSelector(
    getCurrentImageRect,
    getUserScale,
    getRotation,
    (state, viewId, parentViewId) => getProjection(state, parentViewId),
    (state, viewId, parentViewId) => getProjection(state, viewId),
    (imageRect, userScale, rotation, parentProjection, minimapProjection) => {

        const { frame: parentFrame, defaultScale: parentDefaultScale } = parentProjection
        const { frame: minimapFrame, defaultScale: minimapDefaultScale } = minimapProjection

        imageRect = imageRect.scale(minimapDefaultScale)

        const imageRectCenter = new Position(imageRect.width / 2, imageRect.height / 2)
        const offset = imageRectCenter.move(imageRect.position.convertToVector().invert().rotate(rotation))
        const adaptedParentToMinimapFrame = parentFrame.unscale(parentDefaultScale / minimapDefaultScale * userScale)

        const viewZone = new Rectangle(
            adaptedParentToMinimapFrame.width,
            adaptedParentToMinimapFrame.height,
            offset.move(new Vector(
                (minimapFrame.width - imageRect.width) / 2,
                (minimapFrame.height - imageRect.height) / 2,
            )),
        )

        return {
            image: imageRect,
            viewingWindow: {
                width: viewZone.width,
                height: viewZone.height,
                position: viewZone.position,
                offset: {
                    x: viewZone.width / 2,
                    y: viewZone.height / 2,
                },
            },
        }
    }
)

export const isProjectionInitialized = createSelector(
    getProjection,
    projection => projection !== null && projection !== undefined,
)

export const isCurrentImageRectInitialized = createSelector(
    getCurrentImageRect,
    imageRect => imageRect !== null && imageRect !== undefined,
)

export const isImageReadyToBeDisplayed = createSelector(
    isCurrentMediaSourceLoaded,
    isProjectionInitialized,
    isCurrentImageRectInitialized,
    (isSourceLoaded, isProjectionInitialized, isCurrentImageRectInitialized) => isSourceLoaded && isProjectionInitialized && isCurrentImageRectInitialized
)

export const mainViewId = "default"
